module.exports = __webpack_public_path__ + "svg/visual-hero.svg";